import { makeApi } from "@zodios/core";
import { z } from "zod";

import { expiringUrlSchema } from "../shared.ts";

export const thumbnailApi = makeApi([
  {
    path: "/thumbnails/:hostId/:nodeId",
    alias: "getThumbnail",
    method: "get",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Path",
        name: "nodeId",
        schema: z.number().int(),
      },
      {
        type: "Query",
        name: "languageCode",
        schema: z.string(),
      },
    ],
    response: expiringUrlSchema.optional(),
  },
  {
    path: "/thumbnails/:hostId/:nodeId/hash",
    alias: "getThumbnailHash",
    method: "get",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Path",
        name: "nodeId",
        schema: z.number().int(),
      },
      {
        type: "Query",
        name: "languageCode",
        schema: z.string(),
      },
    ],
    response: z.string().optional(),
  },
  {
    path: "/thumbnails/:hostId/:nodeId/upload/:hash",
    alias: "uploadThumbnail",
    method: "get",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Path",
        name: "nodeId",
        schema: z.number().int(),
      },
      {
        type: "Path",
        name: "hash",
        schema: z.string(),
      },
      {
        type: "Query",
        name: "languageCode",
        schema: z.string(),
      },
    ],
    response: expiringUrlSchema,
    status: 201,
  },
]);
